import { Component, OnInit } from '@angular/core';
import { RefundSuccessModalComponent } from '@lib/shared';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({ standalone: false, selector: 'app-refund-success-modal', templateUrl: './refund-success.component.html' })
export class CustomRefundSuccessModalComponent extends RefundSuccessModalComponent implements OnInit {
  constructor(protected bsModalRef: BsModalRef) {
    super(bsModalRef);
  }
}
